import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

const PowerPlansComponent = ({ plans, item, changePlan }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const layout = useSelector((state) => state.layout)
  
  return (
    <div>
      <h1>Velg abonnement</h1>
      {plans.map((plan) => {
        const priceStr = ` (${plan.amount || ''}/mnd)`
        return (
          <div className="input_wrapper" key={`plan-${plan.id}`}>
            <input
              type="radio"
              value={plan.id}
              id={`plan-${plan.id}`}
              checked={plan.id === item.planId}
              onClick={(e) => changePlan(e.target.value)}
              onChange={(e) => {}}
            />
            <label htmlFor={`plan-${plan.id}`}>
              <span>{`${plan.name}${priceStr}`}</span>
            </label>
          </div>
        )
      })}
    </div>
  )
}

export default PowerPlansComponent
